<mat-progress-bar color="primary" [@progressFade] *ngIf="newspaperFacade.isLoading$ | async" mode="indeterminate"></mat-progress-bar>
<div class="search">
	<ng-container *ngIf="pageFacade.selected$ | async as page">
		<shop-contentblocks [blocks]="page.blocks"></shop-contentblocks>
	</ng-container>

	<section class="container search-form__container">
		<shop-searchresult-book *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Book"></shop-searchresult-book>
		<shop-searchresult-year-book *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.YearBook"></shop-searchresult-year-book>
		<shop-searchresult-cd *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Cd"></shop-searchresult-cd>
		<shop-searchresult-dvd *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Dvd"></shop-searchresult-dvd>
		<shop-searchresult-coin *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Coin"></shop-searchresult-coin>
		<shop-searchresult-chronicle *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Chronicle"></shop-searchresult-chronicle>
		<shop-searchresult-folder *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Folder"></shop-searchresult-folder>
		<shop-searchresult-stick *ngIf="(routerFacade.articleKind$ | async) == ArticleKinds.Stick"></shop-searchresult-stick>
	</section>
</div>
